;(function ($, _, window) {
    /** 
    * ECHTINTERACTIE, http://wijzijnecht.nl
    * Lodash Template dom object needed:
    *
    <script type="text/template" id="TmplCookieLaw">
        <div class="cookie-wrapper">
            <div class="row">
                <div class="cookie-text">
                    Text
                    <button class="button cookie-button">Accept</button>
                </div>
            </div>
        </div>
    </script>
    */ 
    var cookieLaw = function ($target, options) {
        /**
         * Check for jquery
         */
        if ($ === undefined) {
            throw '[data-slider] jquery is required';
        }

        /**
         * Check for lodash
         */
        if (_ === undefined) {
            throw '[data-slider] lodash is required';
        }
        
        /**
        * Set local variables
        */
        var config = {
    		target: 'body',
    		wrapper: '.cookie-wrapper',
    		button: '.cookie-button',
    		cookie: {
        		cname: 'EurocrossCookie',
        		value: 'Europe Cookie Law',
        		exp: 365
    		}
	    }; 
        
        this.options = $.extend(true, config, options);
        
        //Check if !Cookie exist
        if(!this._checkCookie()) {
            this.$tmpl =  _.template($target.html());
        
            //call _init function
            this._init();
        }
    };


    /**
    *  init Cookie function  
    **/    
    cookieLaw.prototype._init = function () {
        var self = this, 
            $obj= $(this.$tmpl());
        
        $obj
            .find(this.options.button)
            .bind('click', function(e) {
                var cookie = this.options.cookie;
                
                this._setCookie(cookie.cname, cookie.value, cookie.exp); //set cookie
                this._removeCookieMessage(); //remove message
                
                e.preventDefault();
            }.bind(this))
            .end()
            .appendTo($(this.options.target));
    };
    
    /**
    *  Set Cookie function  
    **/ 
    cookieLaw.prototype._setCookie = function (c_name, value, expiredays) {
        var exdate=new Date();

        exdate.setDate(exdate.getDate()+expiredays);//set exp date
        document.cookie=c_name+ "=" +escape(value)+";path=/"+((expiredays==null) ? "" : ";expires="+exdate.toGMTString()); //place cookie
    };
    
    /**
    *  Check Cookie function  
    **/ 
    cookieLaw.prototype._checkCookie = function () {
        var exsist = document.cookie.indexOf(this.options.cookie.cname+"=") >=0 ? true : false;
        return exsist;
    };
    
    /**
    *  remove Cookie message function  
    **/ 
    cookieLaw.prototype._removeCookieMessage = function () {
        //remove message
        $(this.options.wrapper).remove();
    }

    /**
     * On DOM ready
     */
    $(function () {
        /**
         * Initialize cookieLaw 
         */
        $('#TmplCookieLaw').each(function () {
            var $target = $(this),
                options = '';
            
            new cookieLaw($target, options);
        });

    });

})(jQuery, _, window);